import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const LOGO_URL = "/logo-prenova.png";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    if (localStorage.getItem("admin_token")) {
        return <Navigate to="/admin" replace />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const r = await api.post("/admin/login", { username, password });
            localStorage.setItem("admin_token", r.data.token);
            localStorage.setItem("admin_username", r.data.admin.username);
            toast.success("Accesso effettuato");
            navigate("/admin");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Credenziali non valide");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-ink px-6 grain" data-testid="admin-login-page">
            <div className="max-w-md w-full">
                <div className="text-center mb-10">
                    <div className="w-40 h-40 rounded-sm mx-auto mb-6 overflow-hidden ring-1 ring-gold/40 shadow-[0_0_30px_rgba(212,175,55,0.2)] bg-[#1a1f3a]">
                        <img src={LOGO_URL} alt="Prenova by Renova360" className="w-full h-full object-contain" />
                    </div>
                    <div className="text-gold text-[10px] tracking-[0.4em] uppercase mb-2">Prenova by Renova360</div>
                    <h1 className="font-serif text-4xl text-white">
                        Pannello <span className="italic text-gold">Ristoratore</span>
                    </h1>
                    <p className="text-gray-400 mt-3 text-sm">Accedi per gestire prenotazioni, tavoli e impostazioni.</p>
                </div>

                <form onSubmit={handleSubmit} className="bg-ink-surface border border-white/10 rounded-sm p-8 space-y-5">
                    <div className="relative">
                        <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={16} strokeWidth={1.5} />
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            data-testid="admin-username-input"
                            className="w-full pl-10 pr-3 py-3 bg-transparent border border-white/20 rounded-sm text-white placeholder-gray-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold"
                        />
                    </div>
                    <div className="relative">
                        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={16} strokeWidth={1.5} />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="admin-password-input"
                            className="w-full pl-10 pr-3 py-3 bg-transparent border border-white/20 rounded-sm text-white placeholder-gray-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit-btn"
                        className="w-full bg-gold text-black font-semibold py-3 rounded-sm hover:bg-gold-light transition-colors disabled:opacity-50 tracking-widest uppercase text-sm"
                    >
                        {loading ? "Accesso..." : "Entra"}
                    </button>
                    <div className="text-right mt-3">
                        <a href="/admin/forgot-password" className="text-[11px] text-gray-400 hover:text-gold tracking-wide" data-testid="admin-forgot-password-link">
                            Hai dimenticato la password?
                        </a>
                    </div>
                </form>
                <div className="text-center mt-5 pt-5 border-t border-white/5 text-[11px] text-gray-500">
                    Non hai un account? <a href="/iscrizione-ristoratore" className="text-gold hover:text-gold-light underline" data-testid="admin-signup-link">Iscrivi il tuo ristorante</a>
                </div>
                <div className="text-center mt-4">
                    <a href="/" className="text-xs text-gray-500 hover:text-gold tracking-widest uppercase">
                        ← Torna al sito
                    </a>
                </div>
            </div>
        </div>
    );
}
